import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";

import { OrderResultDialogMobile } from "./OrderResultDialogMobile";
import { OrderResultDialogDesktop } from "./OrderResultDialogDesktop";
import { useOrderResultDialog } from "./useOrderResultDialog";

export function OrderResultDialog(props) {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { open, header, createdList, failedList } = useOrderResultDialog(
    props.result
  );

  if (!open || !header) return null;

  const commonProps = { ...props, header, createdList, failedList };

  return isMobile ? (
    <OrderResultDialogMobile {...commonProps} />
  ) : (
    <OrderResultDialogDesktop {...commonProps} />
  );
}
